var _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgMulticurrency({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 55.4187,
    cy: 116.394,
    rx: 55.4187,
    ry: 55.4187,
    transform: "rotate(-90 55.4187 116.394)",
    fill: "#FCE400"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 124.581,
    cy: 116.394,
    rx: 55.4187,
    ry: 55.4187,
    transform: "rotate(-90 124.581 116.394)",
    fill: "#FCE400"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 90.8864,
    cy: 61.4186,
    rx: 55.4187,
    ry: 55.4187,
    transform: "rotate(-90 90.8864 61.4186)",
    fill: "#FCE400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgMulticurrency);
export default __webpack_public_path__ + "static/media/IMG_multicurrency.43231e6cd1051ecafaf5ed67e55fadee.svg";
export { ForwardRef as ReactComponent };